/* Scrollable, wrapping preview of the shared text awaiting confirm.
 * `pre` so whitespace is preserved; capped height keeps long shares
 * from pushing the confirm/cancel buttons off-screen. */
.preview {
  margin: 0;
  max-height: 12rem;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  border: 1px solid var(--stroke-neutral);
  border-radius: var(--radius-12);
  background: var(--bg-secondary);
  font: var(--text-micro-regular);
}
